/**
 * Google Maps / Places — used for location autocomplete on signup.
 * Add your site URLs (e.g. http://localhost:3001/*) under HTTP referrers in Google Cloud.
 */
const PRODUCTION_FALLBACK_KEY =
  "AIzaSyBQO4HZtS9qujVpXX3Gr2w_6v5C6PujKf8";

const envKey = (process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "").trim();

export const GOOGLE_MAPS_API_KEY = envKey || PRODUCTION_FALLBACK_KEY;

export const GOOGLE_MAPS_ENABLED = Boolean(GOOGLE_MAPS_API_KEY);

export const GOOGLE_MAPS_LIBRARIES = ["places"];
